import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Header } from "semantic-ui-react";

import RedirectWithReset from "../../components/utils/RedirectWithReset.jsx";
import UnauthorisedFeature from "../../components/auth/UnauthorisedFeature.jsx";
import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import InvitePanel from "../../components/invites/invitePanel/InvitePanel.jsx";

import withConfirmationModal from "../../components/modals/withConfirmationModal.js";

import { getInvite } from "../../state/reducers/invites/invitesActions.js";
import { getAccount } from "../../state/reducers/account/accountActions.js";
import { coreFullRefreshAction } from "../../state/reducers/core/coreActions.js";
import { inviteOperationAction } from "../../state/reducers/invites/invitesActions.js";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";
import { ROUTES } from "../../constants/routing.js";

import inviteSelector from "../../state/reducers/invites/inviteSelector.js";
import endpointSelector from "../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Invite extends Component {
  static propTypes = {
    invites: PropTypes.array,
    dispatchGetInvite: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    listInviteAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const id = props.match.params.id;

    this.state = {
      atId: `${ROUTES.INVITES}/${id}`,
      modalAction: false,
      redirect: null
    };
  }

  // -- PAGE DATA MANAGEMENT -- //

  componentDidMount = () => {
    const {
      dispatchGetInvite,
      listInviteAvailability: { permitted, enabled }
    } = this.props;
    if (permitted && enabled) {
      dispatchGetInvite(this.state.atId);
    }
  };

  // -- HANDLERS -- //

  createOptionsWithSuccess = options => {
    return {
      ...options,
      success: [
        getAccount(),
        coreFullRefreshAction(),
        getInvite(this.state.atId)
      ],
      autoComplete: false
    };
  };

  handleModal = (invite, operationName, data, options) => {
    const { openModal } = this.props;

    const modalAction = inviteOperationAction(
      invite,
      operationName,
      data,
      this.createOptionsWithSuccess(options)
    );

    const modalCopyKey = `invite.modals.${operationName}_modal`;

    this.setState({ modalAction }, () => {
      openModal(this.doModalAction, modalCopyKey);
    });
  };

  doModalAction = () => {
    this.props.dispatchAction(this.state.modalAction);
  };

  doOperationAction = (invite, operationName, data, options) => {
    this.props.dispatchAction(
      inviteOperationAction(
        invite,
        operationName,
        data,
        this.createOptionsWithSuccess(options)
      )
    );
  };

  // -- RENDER -- //

  renderInvites = () => {
    const { invites } = this.props;

    return invites.map(invite => {
      return (
        <InvitePanel
          key={invite["@id"]}
          invite={invite}
          onAccept={this.doOperationAction}
          onReject={this.handleModal}
          onDelete={this.handleModal}
        />
      );
    });
  };

  render() {
    const { redirect } = this.state;
    const {
      invites,
      isFetching,
      listInviteAvailability: { permitted, enabled },
      copy
    } = this.props;

    if (redirect) {
      return (
        <RedirectWithReset to={`${location.pathname}${redirect}`} push={true} />
      );
    }

    if (!permitted) {
      return <UnauthorisedFeature title={copy("invites.title")} />;
    }

    // early return if project isn't ready to render
    if (isFetching) {
      return <SimplePreloader />;
    }

    // no invites available
    if (!enabled || !invites || invites.length < 1) {
      return (
        <Container className="main-responsive">
          <Header as="h3">{copy("invites.title")}</Header>
          <p>{copy("invites.no_invites")}</p>
        </Container>
      );
    }

    // render invites
    return (
      <Container className="main-responsive">
        <Header as="h3">{copy("invites.title")}</Header>

        {this.renderInvites()}
      </Container>
    );
  }
}

const mapStateToProps = (state, props) => ({
  invites: inviteSelector.selectInvites()(state, props),
  isFetching: state.invites.isFetching,
  listInviteAvailability: endpointSelector.selectOperationAvailability(state)(
    AT_TYPES.INVITE,
    OPERATIONS.LIST
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  dispatchGetInvite: (...args) => dispatch(getInvite(...args)),
  dispatchAction: action => dispatch(action)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withConfirmationModal(Invite));
